import React from 'react'

import { TemplatePage } from 'components'
import { Redirect, Route, RouteProps, useHistory } from 'react-router'

export interface IRouteWithTitle extends RouteProps {
  title?: string
  secondTitle?: string
  page?: React.ReactNode
  hideMenus?: boolean
  childrenOf?: string
  redirectTo?: string | readonly string[]
  permitions?: number[]
  isLogged?: boolean
  isCsn?: boolean
  perfilId?: number
  location?: any
}

const RouteWithTitle = ({
  permitions,
  path,
  page,
  title,
  hideMenus,
  location,
  isLogged = false,
  isCsn = false,
  perfilId,
  ...props
}: IRouteWithTitle) => {
  /**
   *
   * SE NAO ESTA LOGADO
   * VAI PRO LOGIN
   *
   *
   *
   */

  if (!isLogged) {
    return (
      <Redirect
        to={{
          pathname: '/',
          state: { from: location }
        }}
      />
    )
  }

  /**
   *
   * SE ESTA LOGADO
   * E PERMISSAO INCLUI
   * OU NAO PRECISA DE PERMISSAO
   * VAI PRA PAGINA
   *
   */

  if (
    (location?.state?.initialPage || permitions?.length > 0 && permitions?.includes(perfilId)) ||
    permitions?.length === 0
  ) {
    return (
      <Route
        path={path}
        component={() => (
          <TemplatePage hideMenus={hideMenus} page={page} title={title} />
        )}
        {...props}
      />
    )
  }

  /**
   *
   * SE NAO
   * VAI PARA MAIN PAGE
   * USUARIO LOGADO
   *
   *
   */

  return (
    <Redirect
      to={{
        pathname: isCsn ? '/ngt' : '/fornecedor',
        state: {
          from: isCsn ? '/ngt' : '/fornecedor',
          noAcess: true
        }
      }}
    />
  )
}

export default RouteWithTitle
